/**
 * Canvas equivalent of RouteIcon.jsx — pie slices with pre-resolved route colours.
 *
 * Unlike RouteIcon (which reads colours from Redux), this generator receives the
 * already-resolved colour strings so it can run outside of a React component tree.
 */
import { generatePieIcon } from './generatePieIcon'

const UNASSIGNED_COLOR = '#FFA726' // orange[300] — matches RouteIcon default

/**
 * @param {string[]} colors  - Resolved hex/named colours, one per route.
 *                             Pass an empty array to get the unassigned circle.
 * @param {object}   opts    - Forwarded to generatePieIcon (size, borderWidth, borderColor)
 * @returns {HTMLCanvasElement}
 */
export function generateRouteIcon(colors, opts = {}) {
  const safeColors = colors && colors.length > 0 ? colors : [UNASSIGNED_COLOR]
  return generatePieIcon(safeColors, { size: 24, borderWidth: 1, borderColor: '#333333', ...opts })
}

export function generateRouteIconUrl(colors, opts = {}) {
  return generateRouteIcon(colors, opts).toDataURL()
}
